import {ReactElement, useContext, useState} from "react";
import {AdminWrapper} from "../AdminWrapper";
import AdminHeader from "../AdminHeader";
import {Tab, TabList, TabPanel, Tabs} from "@zendeskgarden/react-tabs";
import {LineItemsTab} from "./LineItemsTab";
import {OperationalTab} from "./OperationalTab";
import {CustomDriverTab} from "./CustomDriverTab";
import {useAllPropertyForecastLocksQuery, VersionType} from "../../../__generated__/generated_types";
import {AuthContext} from "../../../contexts/AuthContext";
import * as css from "./styles/lineItemManagement.module.scss";
import {Dropdown, Field, Item, Label, Menu, Select} from "@zendeskgarden/react-dropdowns";
import FeatureRestrictedOverlay from "../../../components/feature-restricted-overlay/FeatureRestrictedOverlay";

enum LineItemManagementTabs {
    LineItems = "line-items",
    Operational = "operational",
    Custom = "custom",
}

export interface LineItemManagementProps {
    budgetYear: number;
}

export function LineItemManagement(props: LineItemManagementProps): ReactElement {
    const [selectedTab, setSelectedTab] = useState<string>(LineItemManagementTabs.LineItems);
    const [versionType, setVersionType] = useState<VersionType.Budget | VersionType.Reforecast>(VersionType.Budget);
    const {operationalMetricTypes} = useContext(AuthContext);
    const {data: locks, loading: locksLoading} = useAllPropertyForecastLocksQuery({
        fetchPolicy: "no-cache",
        variables: {
            budgetYear: props.budgetYear
        }
    });

    return <AdminWrapper>
        <FeatureRestrictedOverlay coverPage />
        <AdminHeader
            title={"Line Items Management"}
            subtitle={"View worksheet line items, operational driver and custom driver data"}
        />
        <Tabs selectedItem={selectedTab} onChange={setSelectedTab}>
            <TabList style={{position: "relative"}}>
                <Tab item={LineItemManagementTabs.LineItems}>Line Items</Tab>
                <Tab item={LineItemManagementTabs.Operational}>Operational</Tab>
                <Tab item={LineItemManagementTabs.Custom}>Custom</Tab>

                <Dropdown onSelect={type => setVersionType(type as VersionType.Budget | VersionType.Reforecast)}>
                    <Field style={{display: "inline-block", position: "absolute", width: "10rem", right: "0px", bottom: "1px"}}>
                        <Label hidden>Forecast Period</Label>
                        <Select style={{border: "none", boxShadow: "none"}}>{versionType === VersionType.Budget ? 'Budget' : 'Reforecast'}</Select>
                    </Field>
                    <Menu>
                        <Item value={VersionType.Budget}>Budget</Item>
                        <Item value={VersionType.Reforecast}>Reforecast</Item>
                    </Menu>
                </Dropdown>
            </TabList>
            <div className={css.tableWrapper}>
                <TabPanel item={LineItemManagementTabs.LineItems}>
                    {selectedTab === LineItemManagementTabs.LineItems ?
                        <LineItemsTab budgetYear={props.budgetYear} versionType={versionType} locks={locks} locksLoading={locksLoading} /> :
                        <></>
                    }
                </TabPanel>
                <TabPanel item={LineItemManagementTabs.Operational}>
                    {selectedTab === LineItemManagementTabs.Operational ?
                        <OperationalTab budgetYear={props.budgetYear} versionType={versionType} operationalMetricTypes={operationalMetricTypes} locks={locks} locksLoading={locksLoading} /> :
                        <></>
                    }
                </TabPanel>
                <TabPanel item={LineItemManagementTabs.Custom}>
                    {selectedTab === LineItemManagementTabs.Custom ?
                        <CustomDriverTab budgetYear={props.budgetYear} versionType={versionType} locks={locks} locksLoading={locksLoading} /> :
                        <></>
                    }
                </TabPanel>
            </div>
        </Tabs>
    </AdminWrapper>;
}
